// extracted by mini-css-extract-plugin
export default {"root":"styles_root__z5WbE","tpTriggerNegative":"styles_tpTriggerNegative__i+qzh","slTriggerNegative":"styles_slTriggerNegative__aXH56"};